import React from 'react';
import {getLocale} from "@apps/Shared/Utils/Utils";
import { CompanyRegistrationsBlockProps } from "@apps/CompanyRegistrations/types";
import { useGetCompanyRegistrationsQuery } from "@apps/Shared/GraphQL/generated";
import CompanyRegistrationsBlock from "@apps/CompanyRegistrations/CompanyRegistrationsBlock";

function App(): JSX.Element {
  const hiddenInput = document.querySelector('.js-company-registrations');
  const id = Number((hiddenInput as HTMLInputElement).value);
  const locale = getLocale();

  const {data} = useGetCompanyRegistrationsQuery({
    id: id,
    locale: [locale]
  });

  if (data?.CompanyRegistrationsBlockModel?.items?.length) {
    const block = data?.CompanyRegistrationsBlockModel.items[0];
    const settings = data?.StartPageModel?.items?.length ? data?.StartPageModel?.items[0] : null;

    const props: CompanyRegistrationsBlockProps = {
      buttonText: block?.ButtonText as string,
      extra1 : block?.Extra1?.Html,
      extra2 : block?.Extra2?.Html,
      extra3 : block?.Extra3?.Html,
      extra4 : block?.Extra4?.Html,
      extra5 : block?.Extra5?.Html,
      helpText: block?.HelpText?.Html,
      form: block?.Form as string,
      termsAndConditions: settings?.StandardTermsAndConditions?.Html,
      customTermsAndConditions: block?.CustomTermsAndConditions?.Html,
      termsAndConditionsButtons: block?.CustomTermsAndConditionsButton,
    }

    return (
      <CompanyRegistrationsBlock {...props} />
    )
  } else {
    return <></>
  }
}

export default App;